/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_Rotate_ResumeInputs */

const en_landing_hero_rotate_resume = /** @type {(inputs: Landing_Hero_Rotate_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`resume`)
};

const de_landing_hero_rotate_resume = /** @type {(inputs: Landing_Hero_Rotate_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf`)
};

const fr_landing_hero_rotate_resume = /** @type {(inputs: Landing_Hero_Rotate_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const es_landing_hero_rotate_resume = /** @type {(inputs: Landing_Hero_Rotate_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`currículum`)
};

const it_landing_hero_rotate_resume = /** @type {(inputs: Landing_Hero_Rotate_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`curriculum`)
};

const nl_landing_hero_rotate_resume = /** @type {(inputs: Landing_Hero_Rotate_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const pl_landing_hero_rotate_resume = /** @type {(inputs: Landing_Hero_Rotate_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const fi_landing_hero_rotate_resume = /** @type {(inputs: Landing_Hero_Rotate_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ansioluettelosi`)
};

const da_landing_hero_rotate_resume = /** @type {(inputs: Landing_Hero_Rotate_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const sv_landing_hero_rotate_resume = /** @type {(inputs: Landing_Hero_Rotate_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

/**
* | output |
* | --- |
* | "resume" |
*
* @param {Landing_Hero_Rotate_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_hero_rotate_resume = /** @type {((inputs?: Landing_Hero_Rotate_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Rotate_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_hero_rotate_resume(inputs)
	if (locale === "fr") return fr_landing_hero_rotate_resume(inputs)
	if (locale === "es") return es_landing_hero_rotate_resume(inputs)
	if (locale === "it") return it_landing_hero_rotate_resume(inputs)
	if (locale === "nl") return nl_landing_hero_rotate_resume(inputs)
	if (locale === "pl") return pl_landing_hero_rotate_resume(inputs)
	if (locale === "fi") return fi_landing_hero_rotate_resume(inputs)
	if (locale === "da") return da_landing_hero_rotate_resume(inputs)
	if (locale === "sv") return sv_landing_hero_rotate_resume(inputs)
	return en_landing_hero_rotate_resume(inputs)
});